import React from 'react';
import useCurrentPath from 'frontend/hooks/useCurrentPath';
import { ROUTE_KEYS } from 'frontend/constants';
import store from "../../../../storeClient"

const BillboardImage = ({ image = '', pathname = '', routesToRenderFullPackageSearch = [] }) => {
  const shouldRenderFullHeight = routesToRenderFullPackageSearch.includes(pathname);

 
  const headerImagen =
  store.getState().applicationState.templateData?.headerImagen[0]?.valor
  const imageUrl = headerImagen || image
  const { isOnTargetPath } = useCurrentPath([ROUTE_KEYS.HOME, ROUTE_KEYS.BUSCAR_X_PAQUETES]);

  return (
    <div className="billboard__container" style={{ aspectRatio: '16/9' }}>
      <img
        className={`background__billboard ${
          shouldRenderFullHeight ? 'full-height' : 'partial-height'
        }`}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
        src={imageUrl}
        alt="Billboard background"
      />
    </div>
  );
};

export default BillboardImage;
